export default "__VITE_ASSET__cdf81b59__"